import React from 'react';
import PropTypes from 'prop-types';
import TimeAgo from 'timeago-react';

import Avatar from "UI/Avatar";
import Card, {CardFooter} from "UI/Card";
import Collage from "UI/Collage";
import PostCardSettingsMenu from "Components/PostList/PostCardSettingsMenu";
import {PhotographIcon, ReplyIcon} from '@heroicons/react/solid';
import Badge from "UI/Badge";
import SocialIcon from "Components/Icons/SocialIcon";

export default class Post extends React.Component
{
    static propTypes = {
        post: PropTypes.object.isRequired,
        integration: PropTypes.object.isRequired,

        media: PropTypes.array.isRequired // ALLL the media..>! :(
    };

    render()
    {
        const { post, integration } = this.props;

        let photos = [];

        if (post.media.length > 0) {
            const remapped = this.props.post.media.map(uuid => this.props.media[uuid]);
            photos = remapMediaSrcProperty(remapped);
        }

        const header = <div className='px-4 pt-4 flex'>
            <div className='flex-grow'>
                {
                    <div className='flex'>
                        <div className='relative'>
                            { integration && <Avatar circular src={integration.picture} /> }
                            <SocialIcon type={post.integration_type} className='bg-white border border-white rounded-full absolute bottom-0 right-0 w-4 h-4' />
                        </div>
                        <div className='ml-4'>
                            <p className="text-sm leading-5 font-medium text-gray-700 group-hover:text-gray-900">
                                {integration ? integration.name : 'Facebook Page'}
                                {
                                    integration && integration.disconnected_at ? ' (disconnected)' : null
                                }
                            </p>
                            <p className="text-xs leading-4 font-medium text-gray-500 group-hover:text-gray-700 group-focus:underline transition ease-in-out duration-150">
                                <DateTime post={post} />
                            </p>
                        </div>
                    </div>
                }
            </div>
            <div className='flex-shrink-0'>
                <PostCardSettingsMenu post={post} integration={integration} />
            </div>
        </div>;

        const footer = <CardFooter className='flex flex-row-reverse space-x-2 space-x-reverse'>
            <Badge>
                <ReplyIcon className='w-3 h-3' />
                <span className='ml-1'>
                    {post.replies.length}
                </span>
            </Badge>
            <Badge>
                <PhotographIcon className='w-3 h-3' />
                <span className='ml-1'>
                    {getImageCount(post)}
                </span>
            </Badge>
        </CardFooter>;

        return <Card header={header} footer={footer}>
            <div className='flex flex-col space-y-4'>
                <p className='whitespace-pre-wrap'>{post.message}</p>
                <div className='-mx-4 sm:-m-6'>
                    <Collage width='100%' height={['128px', '128px']} layout={[2,2]} photos={photos} />
                </div>
            </div>
        </Card>;
    }
}

const DateTime = ({post}) => {
    if (post.status === 'draft') {
        return 'Draft';
    }

    if (post.status === 'scheduled') {
        return <TimeAgo datetime={post.scheduled_for} />;
    }

    if (post.status === 'shared' ) {
        return <TimeAgo datetime={post.published_at} />;
    }
}

function remapMediaSrcProperty(media) {
    return media.map(item => ({
        ...item,
        src: item ? item.filename : null   // yeah, this is the url... :(
    }))
}

function getImageCount(post) {
    let initialCount = post.media.length;

    if (post.replies.length < 1) {
        return initialCount;
    }

    return post.replies.reduce(
        (value, reply) => value + reply.media.length,
        initialCount
    );
}
